import { Controller } from '@hotwired/stimulus';

// A curated title carries its category, so a pick answers the category too. That answer is
// on loan: editing the title away from the suggestion takes it back, unless the employer has
// since chosen a category themselves.
export default class extends Controller {
  static targets = ['title'];

  static outlets = ['select-field-component'];

  fill({ detail: { title, category_id: categoryId } }) {
    if (categoryId === null || categoryId === undefined) return;

    const value = String(categoryId);
    // The curated list can still name a category that has since been retired.
    if (!this.category.options[value]) return;

    this.category.setValue(value);
    this.loan = { value, title };
  }

  titleEdited() {
    if (!this.loan || this.titleTarget.value === this.loan.title) return;

    if (this.category.getValue() === this.loan.value) this.category.clear();
    this.loan = null;
  }

  get category() {
    return this.selectFieldComponentOutlet.tomSelect;
  }
}
